import { useState } from 'react';
import { useFishDetails } from '../FishDetailsContext';
import { Card } from '@Components/Card/index';
import ShowFor from '@Components/ShowFor';
import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import EmailPanel from '@Components/EmailPanel';
import { useStickToBottom } from '@Hooks/useStickToBottom';


export default function MessagesPanel() {
  const [selected, setSelected] = useState('sms');
  const {
    actor,
    allMessages,
    openModal,
    setModalContent,
  } = useFishDetails();
  const smsScrollRef = useStickToBottom(allMessages, selected);

  return (
    <>
      <div className="flex h-full flex-col">
        {/* Selector */}
        <div className="flex items-center gap-6">
          <div className="flex items-stretch gap-1 rounded-lg bg-zinc-900 p-1 border">
            <Button
              variant={selected === 'sms' ? 'secondary' : 'ghost'}
              size="sm"
              onClick={() => setSelected('sms')}
            >
              SMS
            </Button>

            <Button
              variant={selected === 'email' ? 'secondary' : 'ghost'}
              size="sm"
              onClick={() => setSelected('email')}
            >
              Email
            </Button>
          </div>
          {selected === 'email' && (
            <div>
              <Button
                variant={'outline'}
                size="lg"
                onClick={() => {
                  setModalContent('email');
                  openModal();
                }}
              >
                New Email
              </Button>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="flex-1 overflow-auto">
          {selected === 'sms' ? (
            <div className="flex min-h-0 flex-1 flex-col pt-4">
              <Card className="flex min-h-0 min-w-25 flex-1 flex-col">
                <div
                  ref={smsScrollRef}
                  className="no-scrollbar flex h-[50vh] flex-col space-y-2 overflow-x-hidden overflow-y-auto px-2"
                >
                  {!allMessages.length && (
                    <p className="py-4 text-sm text-zinc-400">
                      No messages found.
                    </p>
                  )}
                  {allMessages.map((msg, index) => {
                    const isInbound = !!msg.sender;
                    const timestamp = new Date(
                      msg.receivedAt || msg.sentAt,
                    ).toLocaleString();

                    return (
                      <div key={index} className={`flex justify-start`}>
                        <div
                          className={`w-full rounded-lg p-2 ${
                            isInbound ? 'bg-zinc-700' : 'bg-sky-900'
                          }`}
                        >
                          <p className="break-all whitespace-pre-wrap">
                            {msg.messageBody}
                          </p>
                          <div className="mt-1 text-xs text-zinc-400">
                            {/*update with sender phone number too eventually*/}
                            {timestamp} {isInbound ? actor.phoneNumber : ''}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <ShowFor permissions={['MEMBERS_WRITE']}>
                  <div className="flex shrink-0 items-center justify-center pt-4">
                    <Button
                      onClick={() => {
                        setModalContent('sms');
                        openModal();
                      }}
                      disabled={!actor.phoneNumber}
                      className={`text-sm font-medium ${
                        actor.phoneNumber
                          ? 'bg-zinc-600 hover:bg-zinc-500'
                          : 'cursor-not-allowed bg-zinc-800 text-zinc-500'
                      }`}
                    >
                      View threads/Send message
                    </Button>
                  </div>
                </ShowFor>
              </Card>
            </div>
          ) : (
            <div className="flex h-full flex-col overflow-auto">
              <EmailPanel fishId={actor?.id} />
            </div>
          )}
        </div>
      </div>


    </>
  );
}
